import axios from "axios";
import { getLs, baseUrl } from ".";
import { toast } from "react-hot-toast";

axios.defaults.baseURL = `${baseUrl}`;
axios.defaults.headers.common["Api-Token"] = getLs("coa_api") || "";
axios.defaults.headers.common["X-Requested-With"] = `XMLHttpRequest`;

const Api = axios.create();

export default Api;
